// extracted by mini-css-extract-plugin
export default {"additional_item":"bL","info_wrapper":"cL","addition_item_img_wrapper":"eL","title":"fL","quantity":"gL","flavors":"hL","old_price":"iL","discount":"jL","button_wrapper":"kL"};
    if(module.hot) {
      // 1726593106761
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  